<script setup lang="ts">

import {computed, ref} from "vue";

const elm = ref(null);
const menus = computed(()=>{
    const root = __MAIN_MENU__.navigator.filter(lv1 => lv1.active);
    for (const lv1 of root) {
        if(lv1.child) {
            lv1.child = lv1.child.filter(lv2 => lv2.active);
        }
    }
    return root;

})

const hideMenu = ()=>{
    elm.value.classList.add("child-hide");
}

const showMenu = ()=>{
    elm.value.classList.remove("child-hide");
}


const emit = defineEmits(["openSpin"]);

function openSpin() {
    emit("openSpin");
}


</script>

<template>
    <ul ref="elm" c2c-0 class="menu" v-if="menus">
        <li v-for="item in menus">
            <a :href="item.link" @mouseover="showMenu" @click="hideMenu">
                <img v-if="item.icon" :src="item.icon" :alt="item.label">
                <span c2c-1 class="ws-nowrap">{{ item.label }}</span>
            </a>
            <ul v-if="item.child">
                <li v-for="child in item.child">
                    <a :href="child.link" @click="hideMenu">
                        {{child.label}}
                    </a>
                </li>
            </ul>
        </li>

        <li>
            <a c2c-2 class="c-0" href="/custom-design-request" @click="hideMenu">
                Custom Design
            </a>
        </li>

        <li c2c-3 class="<2 none">
            <a c2c-4 class="bg-red c-0 p-2-5 fs-14 p-6-12 cur-1" href="/official-notice">
                Official Notice
            </a>
        </li>

    </ul>

</template>

<style lang="scss" scoped>
@keyframes spin {
    0% {
        -moz-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    100% {
        -moz-transform: rotate(359deg);
        -o-transform: rotate(359deg);
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}

.menu {
    li {
        &:hover {
            a {
                img {
                    animation: spin 5s linear infinite;
                }
            }
            ul {
                display: block;
            }
        }
    }
    &.child-hide {
        li {
            ul {
                display: none;
            }
        }
    }
}
</style>
<style lang="scss" scoped>.ws-nowrap[c2c-1] {
                        white-space: nowrap;
                 }.c-0[c2c-2] {
                        color: hsl(0, 0%, 100%);
                 }@media (max-width: 768px) {.\<2.none[c2c-3] {
                        display: none;
                 }}.bg-red[c2c-4] {
                        background-color: hsl(0, 100%, 50%);
                 }.c-0[c2c-4] {
                        color: hsl(0, 0%, 100%);
                 }.p-2-5[c2c-4] {
                        padding-top: 2px;padding-right: 5px;padding-bottom: 2px;padding-left: 5px;
                 }.fs-14[c2c-4] {
                        font-size: 14px;
                 }.p-6-12[c2c-4] {
                        padding-top: 6px;padding-right: 12px;padding-bottom: 6px;padding-left: 12px;
                 }.cur-1[c2c-4] {
                        cursor: pointer;
                 }</style>